<template>
  <div v-if="audio" class="w-100">
    <audio
      type="audio/mpeg"
      controls=""
      controlsList="noplaybackrate nodownload"
      class="w-100"
      :source="audio.src"
      ref="audio"
      :autoplay="autoplay"
    >
      <source
        :src="audio.src"
      />
    </audio>
  </div>
</template>

<script>
import { IS_SAFARI } from '@/organisation/constants';

export default {
  name: 'Audio',
  props: {
    source: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      audio: null,
      playing: false,
      progress: 0,
      fastForwarded: false,
      listenersAdded: false,
      timeOutRunning: false,
    };
  },
  methods: {
    setProgress() {
      if (!this.$refs.audio) {
        this.progress = 0;
        return;
      }

      const newProgress = this.$refs.audio.currentTime / this.audio.duration;
      const expectedProgress = this.progress + (1 / this.audio.duration);

      if (newProgress - expectedProgress > 0.1) {
        // User fast forwarded the audio;
        this.fastForwarded = true;
        this.progress = 0;
      } else {
        this.progress = newProgress;

        if (this.progress >= 1) {
          this.$emit('finished');
        }
      }
    },
    emitProgress() {
      if (!this.timeOutRunning) {
        this.timeOutRunning = true;
        setTimeout(
          () => {
            this.setProgress();
            this.$emit('playing', {
              progress: this.progress,
              fastForwarded: this.fastForwarded,
            });
            if (this.playing) {
              this.timeOutRunning = false;
              this.emitProgress();
            }
          },
          1000,
        );
      }
    },
    async loadMp3File() {
      const blob = await fetch(this.source)
        .then((resp) => resp.blob());
      const audio = new Audio(URL.createObjectURL(blob));
      audio.controls = false;
      this.audio = audio;
      // eslint-disable-next-line no-return-assign
      audio.addEventListener('loadedmetadata', () => {
        this.setEventListeners();
      });
    },
    setEventListeners() {
      if (!this.listenersAdded) {
        this.$refs.audio.addEventListener('playing', () => {
          this.$emit('play');
          this.playing = true;
          this.emitProgress();
        });

        this.$refs.audio.addEventListener('pause', () => {
          this.$emit('pause');
          this.playing = false;
          this.timeOutRunning = false;
        });

        this.$refs.audio.addEventListener(IS_SAFARI ? 'ended' : 'complete', () => {
          this.$emit('finished');
          this.playing = false;
        });

        this.listenersAdded = true;
      }
    },
  },
  mounted() {
    this.loadMp3File();
  },
};
</script>
